import { render, staticRenderFns } from "./LearningProgress.vue?vue&type=template&id=715e1650&scoped=true&"
import script from "./LearningProgress.vue?vue&type=script&lang=js&"
export * from "./LearningProgress.vue?vue&type=script&lang=js&"
import style0 from "./LearningProgress.vue?vue&type=style&index=0&id=715e1650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715e1650",
  null
  
)

export default component.exports